import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';

export interface IState {
  loading: boolean;
  count: number;
  items: any[];
}

export const saleEndpoints = {
  deleteAllItems: createAsyncThunk('sale/deleteAllItems', async (payload: any) => {
    const response = await ApiService.post(`/bulk_sales_delete/?campaign_id=${payload.campaign_id}`, payload);

    return response.data;
  }),
};
export const saleSlice = createSlice({
  name: 'sale',
  initialState: {
    loading: false,
    count: 0,
    items: [],
  } as IState,
  reducers: {},
});

export const saleActions = saleSlice.actions;

export type SaleSlice = {
  [saleSlice.name]: ReturnType<(typeof saleSlice)['reducer']>;
};
